interface Props {
  label: string;
  value: string;
  hint?: string;
  tooltip?: string;
  loading?: boolean;
}

export function KPICard({ label, value, hint, tooltip, loading }: Props): JSX.Element {
  return (
    <div
      className="bg-slate-900/60 border border-slate-800 rounded-xl p-5 flex flex-col gap-2"
      title={tooltip ?? ''}
    >
      <div className="text-xs uppercase tracking-wider text-slate-500">{label}</div>
      {loading === true ? (
        <div className="h-7 w-24 bg-slate-800 rounded animate-pulse" />
      ) : (
        <div className="text-2xl font-bold text-slate-100">{value}</div>
      )}
      {hint !== undefined && hint !== '' && (
        <div className="text-[11px] text-slate-500">{hint}</div>
      )}
    </div>
  );
}
